module.exports = __webpack_public_path__ + "img/icon-less.db1f8193.svg";